import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { Subtitle, Title } from '@/shared/auth/components/common/card'
import { AuthPendingComponent } from '@/shared/auth/components/common/pending-component'
import { SignupInviteForm } from '@/shared/auth/components/forms/signup-invite'

const searchSchema = z.object({
	__clerk_ticket: z.string(),
	__clerk_status: z.string(),
})

export const Route = createFileRoute('/signup/invite')({
	validateSearch: zodValidator(searchSchema),

	component: RouteComponent,
	pendingComponent: AuthPendingComponent,
	// TODO: error component for when, for example, missing __clerk_ticket param
})

function RouteComponent() {
	const { __clerk_ticket } = Route.useSearch()

	return (
		<>
			<title>Signup | BitLyft AIR®</title>

			<Title>Signup</Title>
			<Subtitle>Sign up to access BitLyft AIR®</Subtitle>

			<SignupInviteForm ticket={__clerk_ticket} />
		</>
	)
}
